/* eslint-disable*/
module.exports = (function(tagsMap) {
  const addLabel = (tile, label) => {
    const h2Container = $('<h2>');
    h2Container.addClass('custom-label').text(label);
    tile.find('.description').prepend(h2Container);
  };

  const tileLoop = (tagsMap, callback, optionalSelector) => {
    // loop over all the tiles
    let tileSelector =
      optionalSelector === undefined ? '.tile' : optionalSelector;
    const tileClass = callback.name;

    $(tileSelector).each((index, value) => {
      const $tile = $(value);
      // if this tile already has a custom tile label, skip it
      if ($tile.hasClass(tileClass)) {
        return true;
      }

      // loop over all tag/label pairs
      if ($tile.data('tags') === undefined) {
        return true;
      }

      for (const tag in tagsMap) {
        // if this tile doesn't have this tag, skip it(
        if ($tile.data('tags').indexOf(tag) === -1) {
          continue;
        }

        if ($tile.data('tags').indexOf(tag) !== -1) {
          callback($tile, tagsMap[tag].label);
          $tile.addClass(tileClass).addClass(tag);
          // break out of the loop so we don't look for any more tags on this tile
          break;
        }
      }
    });
  };

  return { tileLoop, addLabel };
})();



// WEBPACK FOOTER //
// ./custom-js/tagging.js